import React from "react";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

import DepositMethodIcon from "@assets/icons/DepositMethodIcon";
import PaymentDetailsIcon from "@assets/icons/PaymentDetailsIcon";
import PaymentProcessIcon from "@assets/icons/PaymentProcessIcon";
import PaymentExecutionIcon from "@assets/icons/PaymentExecutionIcon";

const DepositStepper = ({ currentStep = 1 }) => {
  const { __ } = useTranslation();

  const steps = [
    {
      id: 1,
      title: __("wallet.deposit.deposit_method"),
      Icon: DepositMethodIcon,
    },
    {
      id: 2,
      title: __("wallet.deposit.payment_details"),
      Icon: PaymentDetailsIcon,
    },
    {
      id: 3,
      title: __("wallet.deposit.payment_process"),
      Icon: PaymentProcessIcon,
    },
    {
      id: 4,
      title: __("wallet.deposit.payment_execution"),
      Icon: PaymentExecutionIcon,
    },
  ];

  return (
    <div className="deposit-stepper">
      {steps.map((step, index) => {
        const Icon = step.Icon;
        const isActive = currentStep === step.id;
        const isDone = currentStep >= step.id;

        return (
          <React.Fragment key={step.id}>
            <div
              className={`deposit-stepper__item ${
                isActive ? "active" : ""
              } ${isDone ? "done" : ""}`}
            >
              <div className="deposit-stepper__icon">
                <Icon />
              </div>

              <span className="deposit-stepper__title">{step.title}</span>
            </div>

            {index !== steps.length - 1 && (
              <div className="deposit-stepper__line" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default DepositStepper;